<template>
  <div id="app">
     <!-- $route.meta.keepAlive为true设置缓存 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <!-- $route.meta.keepAlive为false正常显示 -->
    <router-view v-if="!$route.meta.keepAlive" />
    <loading-gif :show-loading="$store.state.LOADING"></loading-gif>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue